import { render } from "./PFLCharts.vue?vue&type=template&id=72648bf3&scoped=true"
import script from "./PFLCharts.vue?vue&type=script&lang=js"
export * from "./PFLCharts.vue?vue&type=script&lang=js"

import "./PFLCharts.vue?vue&type=style&index=0&id=72648bf3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72648bf3"]])

export default __exports__